import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";

const OrgEnvConfig = Loadable(
  lazy(() =>
    import("./OrgEnvConfigList").then(({ OrgEnvConfigList }) => ({
      default: OrgEnvConfigList,
    }))
  )
);

export const orgEnvConfigRoutes = [
	{
		path: "/org-env-config",
		exact: true,
		element: (
			<AuthorizedRoute
				
				moduleIds={[ALLOWED_MODULES.ORG_ENV_CONFIG]}
			>
				<OrgEnvConfig />
			</AuthorizedRoute>
		),
	},
];
